export const CONTACT_MODES_UPDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.OfferPartnerContactModesUpdated";

export const CONTACT_MODES_INVALIDATED =
  "Charisma.Leasing.PublishedLanguage.Events.LeasingOffer.Client.OfferPartnerContactModesInvalidated";
